// ADR-017 Fase 4: SQLite local eliminado — leer de remote/cache.
import { getCatalogRamSnapshotCache } from '../../catalog/infra/catalogRamSnapshotCache';
import { getWebCustomerSnapshotCache } from '../../customers/infra/webCustomerSnapshotCache';
import {
  CATALOG_LAST_PULL_AT_KEY,
  CUSTOMER_LAST_PULL_AT_KEY,
  getSyncTimestampMemory,
} from './syncTimestamps';

/**
 * Conteos locales tras un snapshot de catálogo (incluye stocks / transferencias / lotes aplicados por el mismo flujo).
 */
export async function readInventoryCountsAfterCatalogPull(): Promise<{
  stocksCount: number;
  stockTransfersCount: number;
  stockLotsCount: number;
  timestamp: string;
}> {
  const ts = new Date().toISOString();
  // ADR-017 Fase 4: SQLite local eliminado — leer de remote/cache.
  const cached = getCatalogRamSnapshotCache();
  return {
    stocksCount: cached?.stocks.length ?? 0,
    stockTransfersCount: cached?.stockTransfers.length ?? 0,
    stockLotsCount: 0,
    timestamp: ts,
  };
}

export async function readCatalogMetaCounts(): Promise<{
  productsCount: number;
  categoriesCount: number;
  brandsCount: number;
  suppliersCount: number;
  timestamp: string;
}> {
  const ts = new Date().toISOString();
  // ADR-017 Fase 4: SQLite local eliminado — leer de remote/cache.
  const cached = getCatalogRamSnapshotCache();
  return {
    productsCount: cached?.products.length ?? 0,
    categoriesCount: cached?.categories.length ?? 0,
    brandsCount: cached?.brands.length ?? 0,
    suppliersCount: cached?.suppliers.length ?? 0,
    timestamp: ts,
  };
}

/** Productos vendibles en POS (excluye misc / Varios), alineado con posExcludeMisc. */
export async function readSellableCatalogProductsCount(): Promise<number> {
  // ADR-017 Fase 4: SQLite local eliminado — leer de remote/cache.
  const cached = getCatalogRamSnapshotCache();
  if (!cached) return 0;
  return cached.products.filter(
    (p) => !p.is_misc && p.is_active !== false
  ).length;
}

export async function readCustomersCustomerCounts(): Promise<{
  customersCount: number;
  customerMovementsCount: number;
  salePaymentAllocationsCount: number;
  timestamp: string;
}> {
  const ts = new Date().toISOString();
  // ADR-017 Fase 4: SQLite local eliminado — leer de remote/cache.
  const cached = getWebCustomerSnapshotCache();
  return {
    customersCount: cached?.customers.length ?? 0,
    customerMovementsCount: cached?.customer_movements.length ?? 0,
    salePaymentAllocationsCount: cached?.sale_payment_allocations.length ?? 0,
    timestamp: ts,
  };
}

export async function getCatalogLastPullAt(): Promise<string | null> {
  return getSyncTimestampMemory(CATALOG_LAST_PULL_AT_KEY);
}

export async function getCustomerLastPullAt(): Promise<string | null> {
  return getSyncTimestampMemory(CUSTOMER_LAST_PULL_AT_KEY);
}
